import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    { id: 1, link: "home" },
    { id: 2, link: "about" },
    { id: 3, link: "portfolio" },
    { id: 4, link: "tech" },
    { id: 5, link: "contact" },
  ];

  return (
    <div
      className="flex justify-between items-center w-full h-20 px-4 text-white bg-gradient-to-r from-gray-900 to-black fixed shadow-lg"
      style={{ zIndex: 50 }} // Ensure the NavBar stays on top
    >
      <div>
        <h1
          style={{ fontFamily: "'Orbitron', sans-serif", color: "#7f8eac" }}
          className="text-5xl ml-2"
        >
          Debabrata
        </h1>
      </div>

      <ul className="hidden md:flex space-x-6">
        {links.map(({ id, link }) => (
          <li
            key={id}
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="cursor-pointer capitalize font-medium text-gray-300 hover:text-white transition duration-300 transform hover:scale-110"
          >
            <Link to={link} smooth duration={500}>
              {link}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        style={{ fontFamily: "'Orbitron', sans-serif" }}
        className="cursor-pointer pr-4 z-10 text-gray-300 md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul
          style={{ fontFamily: "'Orbitron', sans-serif" }}
          className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-300 transition duration-300 ease-in-out"
        >
          {links.map(({ id, link }) => (
            <li
              key={id}
              style={{ fontFamily: "'Orbitron', sans-serif" }}
              className="cursor-pointer capitalize py-6 text-4xl hover:text-white transition duration-300 transform hover:scale-110"
            >
              <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;






